/**
 * Extract text content from HTML
 * @param html HTML content to convert to text
 * @returns Plain text extracted from HTML
 */
export const parseTextFromHTML = html => {
  if (!html) return '';

  // Use DOMParser to parse HTML content
  const parser = new DOMParser();
  try {
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  } catch (error) {
    console.error('Error parsing HTML:', error);
    return '';
  }
};

/**
 * Strip all newline characters from a string
 * @param text The input text to process
 * @returns The text with all newlines removed
 */
export const removeNewlines = text => {
  if (!text) return '';

  // Replace all types of newlines (CR, LF, CRLF) with empty string
  // \r\n is a carriage return and line feed, \n is a line feed, \r is a carriage return
  return text.replace(/\r\n|\n|\r/gm, '');
};